import { createContext } from 'react';
import type { SupportedLanguage } from '../i18n';
import { supportedLanguages } from '../i18n';

export interface LanguageContextType {
  language: SupportedLanguage;
  changeLanguage: (lang: SupportedLanguage) => void;
  isRTL: boolean;
  direction: 'rtl' | 'ltr';
  supportedLanguages: typeof supportedLanguages;
  t: (key: string, options?: Record<string, unknown>) => string;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
